// src/components/StoreCtaCard.tsx
// Dark "download the app" card with the official store badges. Used at the bottom of the home page
// and of the Chot Buddies page.
import React from 'react';
import styled from 'styled-components';
import StoreBadgeLink from './StoreBadgeLink';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '../constants/storeLinks';

const Card = styled.div`
  position: relative;
  border-radius: 20px;
  padding: 52px 36px;
  background: linear-gradient(140deg, #0a1420 0%, #1c3650 100%);
  text-align: center;
  overflow: hidden;
  box-shadow: 0 28px 56px rgba(10, 20, 32, 0.35);

  &::before {
    content: '';
    position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
    width: 500px;
    height: 300px;
    background: radial-gradient(ellipse at center, rgba(129, 127, 253, 0.22) 0%, transparent 70%);
    pointer-events: none;
  }
`;

const Headline = styled.h2`
  color: #ffffff;
  margin: 0 0 12px;
  position: relative;
  z-index: 1;
`;

const Tagline = styled.p`
  font-size: 15px;
  color: rgba(255, 255, 255, 0.58);
  margin: 0 0 32px;
  line-height: 1.65;
  position: relative;
  z-index: 1;
`;

const BadgeRow = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: 100%;
  padding: 32px 36px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 1;

  @media (max-width: 560px) {
    flex-direction: column;
    padding: 28px 24px;
  }
`;

interface StoreCtaCardProps {
  headline: string;
  tagline: string;
}

const StoreCtaCard: React.FC<StoreCtaCardProps> = ({ headline, tagline }) => (
  <Card>
    <Headline>{headline}</Headline>
    <Tagline>{tagline}</Tagline>
    <BadgeRow>
      <StoreBadgeLink store="google-play" href={GOOGLE_PLAY_URL} label="Get it on Google Play" />
      <StoreBadgeLink store="apple" href={APP_STORE_URL} label="Download on the App Store" />
    </BadgeRow>
  </Card>
);

export default StoreCtaCard;
